import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { selectIsRedirectionRequired, selectIsUsedDefaultPassword, selectSuperAdminPasswordRequired } from './authSlice';

const PublicRoute = () => {
  const token = useSelector((state) => state.auth.accessToken);
  const superAdminRequired = useSelector(selectSuperAdminPasswordRequired);
  const isDefaultPasswordUsed = useSelector(selectIsUsedDefaultPassword);
  const isRedirectionRequired = useSelector(selectIsRedirectionRequired);
  
  if(token && isRedirectionRequired)
  { 
    return <>Redirecting...</>;
  }
  
  if (token && !superAdminRequired && !isDefaultPasswordUsed) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
};

export default PublicRoute;
